import * as vis from './visibility';

document.addEventListener('turbolinks:load', (e) => {
  const closeFlash = document.getElementById('close-flash');
  const container = document.getElementById('flash-container');
  if(closeFlash && container) closeFlash.addEventListener('click', (e) => {
    vis.hide(container)
  });
});
